import React from 'react';

import Icon from '../Icon';

function Radio({
  className,
  checked,
  renderRight,
  upperCaseText,
  ...props
}) {
  return (
    <div
      className={`Radio ${checked ? 'Radio--checked ' : ''}${className || ''}`}
      {...props}
    >
      <Icon
        className="Radio__icon"
        name={checked ? 'radio_button_checked' : 'radio_button_unchecked'}
      />
      <span className={`Radio__label ${upperCaseText && 'label_Uppercase'}`}>{props.label}</span>
      {renderRight && (
        <span className="Radio__right">
          {renderRight()}
        </span>
      )}
    </div>
  );
}

export default Radio;
